import { render, staticRenderFns } from "./PastJob.vue?vue&type=template&id=67b1befb&scoped=true&"
import script from "./PastJob.vue?vue&type=script&lang=ts&"
export * from "./PastJob.vue?vue&type=script&lang=ts&"
import style0 from "./PastJob.vue?vue&type=style&index=0&id=67b1befb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b1befb",
  null
  
)

export default component.exports